var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEur(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#003399"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 2L7.80615 2.56663H7.1792L7.68646 2.91678L7.49282 3.4834L8.00008 3.13326L8.50733 3.4834L8.3137 2.91678L8.82095 2.56663H8.194L8.00008 2Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.194 12.4075L8.00008 11.8408L7.80615 12.4075H7.1792L7.68646 12.7576L7.49282 13.3242L8.00008 12.9741L8.50733 13.3242L8.3137 12.7576L8.82095 12.4075H8.194Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82088 8.05318L3.32813 8.40333L3.1345 7.8367L3.64175 7.48655H3.0148L2.82088 6.91992L2.62695 7.48655H2L2.50726 7.8367L2.31362 8.40333L2.82088 8.05318Z",
    fill: "#FFCC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41023 2.6582L5.21631 3.22456H4.58936L5.09661 3.57498L4.90297 4.14161L5.41023 3.79119L5.91749 4.14161L5.72385 3.57498L6.23111 3.22456H5.60416L5.41023 2.6582Z",
    fill: "#FFCC00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51477 4.45996L3.32084 5.02659H2.6936L3.20115 5.37674L3.00722 5.94337L3.51477 5.59322L4.02203 5.94337L3.8281 5.37674L4.33564 5.02659H3.70841L3.51477 4.45996Z",
    fill: "#FFCC00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70841 9.94651L3.51477 9.37988L3.32084 9.94651H2.6936L3.20115 10.2967L3.00722 10.8633L3.51477 10.5131L4.02203 10.8633L3.8281 10.2967L4.33564 9.94651H3.70841Z",
    fill: "#FFCC00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60416 11.7473L5.41023 11.1807L5.21631 11.7473H4.58936L5.09661 12.0977L4.90297 12.6643L5.41023 12.3139L5.91749 12.6643L5.72385 12.0977L6.23111 11.7473H5.60416Z",
    fill: "#FFCC00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 7.48655H13.373L13.179 6.91992L12.9851 7.48655H12.3582L12.8654 7.8367L12.6718 8.40333L13.179 8.05318L13.6863 8.40333L13.4927 7.8367L13.9999 7.48655Z",
    fill: "#FFCC00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5894 2.6582L10.3955 3.22456H9.76855L10.2758 3.57498L10.0822 4.14161L10.5894 3.79119L11.0967 4.14161L10.9031 3.57498L11.4103 3.22456H10.7834L10.5894 2.6582Z",
    fill: "#FFCC00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1714 5.37674L11.9774 5.94337L12.4847 5.59322L12.9922 5.94337L12.7983 5.37674L13.3059 5.02659H12.6786L12.4847 4.45996L12.2911 5.02659H11.6638L12.1714 5.37674Z",
    fill: "#FFCC00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6786 9.94651L12.4847 9.37988L12.2911 9.94651H11.6638L12.1714 10.2967L11.9774 10.8633L12.4847 10.5131L12.9922 10.8633L12.7983 10.2967L13.3059 9.94651H12.6786Z",
    fill: "#FFCC00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7834 11.7473L10.5894 11.1807L10.3955 11.7473H9.76855L10.2758 12.0977L10.0822 12.6643L10.5894 12.3139L11.0967 12.6643L10.9031 12.0977L11.4103 11.7473H10.7834Z",
    fill: "#FFCC00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEur);
export default __webpack_public_path__ + "static/media/eur.4fd5baaf1d7a15dc4abc0a1cf546ffcd.svg";
export { ForwardRef as ReactComponent };